import type { MortgageRateResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import type { MortgageRateBand } from "web_myplann/Inspiration/Types/MortgageRateBand";

type Args = {
	ltvPercent: number;
	amount: number;
	maturityYears: number;
};

export const selectMortgageRateBand = (
	rows: MortgageRateResponseDTO[],
	{ ltvPercent, amount, maturityYears }: Args,
): MortgageRateBand | null => {
	const ratesByBank = new Map<number, number>();

	for (const row of rows) {
		const fitsLtv = ltvPercent >= row.ltvFrom && ltvPercent <= row.ltvTo;
		const fitsAmount =
			amount >= row.amountFrom &&
			(row.amountTo == null || amount <= row.amountTo);
		const fitsMaturity =
			maturityYears >= row.maturityFrom && maturityYears <= row.maturityTo;

		if (fitsLtv && fitsAmount && fitsMaturity) {
			ratesByBank.set(row.bankId, row.rate);
		}
	}

	const rates = [...ratesByBank.values()];
	if (rates.length === 0) return null;

	return { best: Math.min(...rates), worst: Math.max(...rates) };
};
